    <div class="mat-elevation-z2 control-strip" *ngIf="showDocuments">

       <div style="display: inline-block; width: 50%; text-align: left; padding-top:5px;">

            <button mat-button *ngIf="addDocuments" class="command-button" style="scale: 95%" 
                    [disabled] = "_caseId<1 || isEditing || _serviceRequest?.recordStatus === 0 ||
                    caseRecord?.caseStatus !== 'Open'"
                    (click)="addNewClickHandler()" matTooltip="Add new document"
                    mat-button>
                <mat-icon>add_circle_outline</mat-icon>
                Add
            </button>

           <mat-checkbox  [(ngModel)]="showOldDocuments" style="padding-left: 10px;padding-top:5px;"  *ngIf="showAllApplicantDocuments"
                          [disabled]="caseRecord?.caseStatus !== 'Open'"
                          (change)="showOldDocumentsSelectionToggle()"> Show all documents for this applicant
           </mat-checkbox>
        </div>

    </div>
             <div class="dwform" style="padding-right: 0px;height: 100%;" *ngIf="showDocuments">
                  <div class="dwform-cell-nopadding" style="min-width: 800px;width: 60%;padding-left: 3px;
					   padding-right: 3px;">
						<div [ngClass]="contentClassName" #tb1
							 class="table-container mat-elevation-z2"
							 	style="height: 93%; border: .5px solid lightgray; outline: none"
							 	(keydown)="tableKeyDown($event)"
				                tabindex="-1">
				                <table mat-table [dataSource]="dataSource" matSort
									   style="width: 100%;"
				                       (matSortChange)="onSortChange($event)">
								<ng-container matColumnDef="icon">
									   <th mat-header-cell *matHeaderCellDef  class="mat-table-header-style-dark"></th>
									   <td mat-cell *matCellDef="let element" style="padding-left: 5px;">
										   <img *ngIf="element.documentName | checkExtension : 'pdf':'NOT'"
										    	(click)="showDocumentPreview(element)"
										    	class="jpeg-icon-style" src="./assets/jpeg_icon.png">
										    <img *ngIf="element.documentName | checkExtension : 'pdf'"
										    	(click)="showDocumentPreview(element)"
										    	class="jpeg-icon-style" src="./assets/pdf_icon.png">
										</td>
								</ng-container>
								 <ng-container matColumnDef="reviewedFlag">
								    <th mat-header-cell *matHeaderCellDef  class="mat-table-header-style-dark"
                                        style="text-align:center"
                                    >Reviewed?
                                    </th>
								    <td mat-cell *matCellDef="let element" style="text-align: center; padding-left: 5px;"
										class="table-row-class">
								    	<mat-checkbox  [(ngModel)]="element.readFlag" *ngIf="reviewedDocuments"
                                                       [disabled]="_serviceRequest.recordStatus !== 1 ||
                                                       caseRecord?.caseStatus !== 'Open'"
					                    	 (change)="reviewedFlagSelectionToggle(element)">
					                     </mat-checkbox>
								    </td>
								 </ng-container>
								 <ng-container matColumnDef="dateAdded">
									  <th mat-header-cell *matHeaderCellDef   class="mat-table-header-style-dark"> Date Added </th>
									  <td mat-cell *matCellDef="let element"  style="padding-left: 1px" class="table-row-class">
									    <span *ngIf="!isEditing">{{element.date_added}}</span>
									  </td>
									</ng-container>
									
								<ng-container matColumnDef="addedBy">
								  <th mat-header-cell *matHeaderCellDef  class="mat-table-header-style-dark"> Added By </th>
								  <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
								    <span *ngIf="!isEditing">{{element.addedBy}}</span>
								  </td>
								</ng-container>
									
								<ng-container matColumnDef="documentType">
								  <th mat-header-cell *matHeaderCellDef class="mat-table-header-style-dark" >Description </th>
								  <td mat-cell *matCellDef="let element" style="padding-left: 1px; max-width:260px;" class="table-row-class">
								  <span>{{trimDescription(element.documentType)}}</span>
								  </td>
								</ng-container>
								<!-- <ng-container matColumnDef="download">
								    <th mat-header-cell *matHeaderCellDef  class="mat-table-header-style-dark"></th>
								    <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
										class="table-row-class">
								    <span>
										 <a (click)="openDocument(element)"style="cursor: pointer;"
                                            *ngIf="_serviceRequest.recordStatus ===1"
                                            class="table-row-class"
											matTooltipPosition="right"
											matTooltip="download document">
										    <mat-icon class="control-icon-style">file_download</mat-icon>
										 </a>
									</span>
								    </td>
								</ng-container> -->
								<ng-container matColumnDef="edit">
							    <th mat-header-cell *matHeaderCellDef  class="mat-table-header-style-dark">
                                    <div *ngIf="!readOnlyFlag && caseRecord?.caseStatus === 'Open'">Edit</div></th>
							    <td mat-cell *matCellDef="let element"  style="padding-left: 1px;padding-right: 6px;" class="table-row-class">
							    	<a style="cursor: pointer;" *ngIf="editDocuments && caseRecord?.caseStatus === 'Open'"
                                       (click)="editCaseDocumentHandler(element)"
									   matTooltipPosition="right"
									   matTooltip="Edit record">
										<mat-icon class="control-icon-style">edit</mat-icon></a></td>
							  	</ng-container>

                				<ng-container matColumnDef="delete">
							    <th mat-header-cell *matHeaderCellDef
                                    class="mat-table-header-style-dark">
                                    <span *ngIf="deleteDocuments && caseRecord?.caseStatus === 'Open'">Delete</span></th>
							    <td mat-cell *matCellDef="let element"  style="padding-left: 1px;padding-right: 6px;"
									class="table-row-class">
							    	<a style="cursor: pointer;" *ngIf="!readOnlyFlag && caseRecord?.caseStatus === 'Open'"
                                       (click)="deleteCaseDocument(element)"
									   matTooltipPosition="right"
									   matTooltip="Delete record">
										<mat-icon class="control-icon-style">delete</mat-icon></a></td>
							    </ng-container>
							  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
			                  <tr mat-row
			                        *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
			                        [ngClass]="{'row-selected': tableRowIdx == Idx}"
							  		(click)="onRowClicked(row)"
							  		(dblclick)="onRowDblClick()">
				                  </tr>
				                </table>
							<app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
				      </div>
				   </div>
  </div>

<p-dialog [header]="strAddEditHeader" [focusOnShow]="false"
          [(visible)]="visibleAddEditDocumentDialog" [modal]="true"
          [style]="{width: '600px', height: '280px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-addeditdocument (cancelClicked)="visibleAddEditDocumentDialog=false" (submitClicked)="submitAddEditWindowHandler()"
						 #addeditdocument></app-addeditdocument>
</p-dialog>

<p-dialog header="Press Escape to close" [focusOnShow]="false" [showHeader]="true"
          [(visible)]="visiblePreviewDocDialog"
		  [modal]="false"
          [style]="{width: '500px', height: '500px'}"
          appendTo="body"
          [minY]="35" [resizable]="true" [closable]="true" >
	<div class="canvas-area">
		<app-docpreview #previewDoc (cancelClicked)="hideDocumentPreview()"></app-docpreview>

	</div>
</p-dialog>


